import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const setDeactivatedOrganization = createAsyncThunk(
  'organizations/setDeactivatedOrganization',
  async ({ orgId, isDeactivated }, { rejectWithValue }) => {
    try {
      // TODO: add api call when backend is ready
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      return {
        orgId,
        isDeactivated,
      };
    } catch (error) {
      return rejectWithValue(error?.response?.status);
    }
  },
);

export const setDeactivatedOrganizationExtraReducers = builder => {
  builder
    .addCase(setDeactivatedOrganization.pending, (state, action) => {
      const { orgId } = action.meta.arg;
      checkAndSetLoadingWithId(
        state.organizations.organization.actions.deactivate.request,
        action,
        orgId,
      );
    })
    .addCase(setDeactivatedOrganization.fulfilled, (state, action) => {
      const { orgId } = action.meta.arg;
      onMatchedRequest(
        state.organizations.organization.actions.deactivate.request[orgId],
        action,
        () => {
          // TODO: set value when backend is ready
        },
      );
    })
    .addCase(setDeactivatedOrganization.rejected, (state, action) => {
      const { orgId } = action.meta.arg;
      handleRequestRejection(
        state.organizations.organization.actions.deactivate.request[orgId],
        action,
      );
    });
};
